import { Component, computed, inject, input, signal } from '@angular/core';
import { BookingService, trackByIndex } from '@beautyapp/core';
import { DatePipe } from '@angular/common';
import { NzPopoverDirective } from 'ng-zorro-antd/popover';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzTagComponent, NzTagModule } from 'ng-zorro-antd/tag';
import { TranslatePipe } from '@ngx-translate/core';
import { rxResource } from '@angular/core/rxjs-interop';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'beautyapp-user-booking-history',
  imports: [
    DatePipe,
    NzPopoverDirective,
    NzTableModule,
    NzTagModule,
    NzToolTipModule,
    NzIconModule,
    TranslatePipe
],
  templateUrl: './user-booking-history.component.html',
  styleUrl: './user-booking-history.component.scss'
})
export class UserBookingHistoryComponent {
  userId = input.required<string>();
  private bookingService: BookingService = inject(BookingService);
  protected readonly trackByIndex = trackByIndex;

  bookingHistoryResource = rxResource({
    params: () => ({
      userId: this.userId(),
      page: this.page(),
      pageSize: this.pageSize(),
      searchValue: this.searchValue()
    }),
    stream: ({ params }) => this.bookingService.getUserBookingHistory({
      page: params.page,
      pageSize: params.pageSize,
      userId: params.userId,
      isDeleted: false
    })
  });

  loadData = computed(() => this.bookingHistoryResource.value()?.data || []);
  loader = computed(() => this.bookingHistoryResource.isLoading());
  total = computed(() => this.bookingHistoryResource.value()?.meta?.itemCount || 0);
  pageSize = signal(10);
  page = signal(1);
  searchValue = signal({} as any);

  expandSet = new Set<number>();

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  paginatorChange(pageEvent: any) {
    this.page.set(pageEvent.pageIndex);
    this.pageSize.set(pageEvent.pageSize);
  }

  // beaut-363: a procedure line is package-covered when it came from a package.
  isPackageService(service: any): boolean {
    return !!service && (service.serviceSource === 'PACKAGE' || !!service.packagePurchaseId);
  }
}
